// Auto-generated by pipeline
export const firebaseConfig = {
  "authDomain": "lpe-49d0d.firebaseapp.com",
  "projectId": "lpe-49d0d",
  "storageBucket": "lpe-49d0d.firebasestorage.app",
  "messagingSenderId": "223744237397",
  "appId": "1:223744237397:web:ed1c4e371a1290cce919dc",
  "measurementId": "G-SRNQ4EBVC5",
  "apiKey": "AIzaSyAjM3MdoYvES5RnSAif5hsJGer7eNN-XR4"
};
